import * as React from 'react';
import styled from 'styled-components';

const SVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
  >
    <rect
      x="30.0898"
      width="29.61"
      height="29.61"
      rx="14.805"
      transform="rotate(90 30.0898 0)"
      fill="white"
    />
    <path
      d="M12 10 L12 20 L20 15 Z"
      fill="#191A1F"
    />
  </svg>
);

const PlayIcon: React.FC<React.SVGProps<SVGSVGElement>> = styled(SVG)`
  display: ${({ display = 'inline-block' }) => display};
  font-size: ${({ fontSize = '32px' }) => fontSize};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;

export default PlayIcon;
